<div class="button-bar">
    @for (button of buttons; track button.label; let i = $index) {
    @if (typeof button.label === 'string') {
    <button [class]="button.class" (click)="button.clickAction()" [id]="button.id">
        @if (button.icon) {
        <i-bs [name]="button.icon"></i-bs>
        }
        {{ button.label }}
    </button>
    } @else {
        <app-segmented-control [labels]="button.label" [selectedLabel]="button.value ?? button.label[0]" (selectionChange)="button.clickAction($event)">
        </app-segmented-control>
    }
    }
</div>